import { useGetTurnosQuery } from "src/gql/schema"
import { useParams } from "react-router-dom"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { useProfile } from "src/shared/hooks/useProfile"

const getDateParam = (date: any, nowHotel: Date) => {
    const parseDate = new Date(date || "")
    const validDate = !isNaN(parseDate.getTime())

    return validDate ? parseDate : nowHotel
}

export function useDateParams() {
    const { formatCustomDate, getStartOfHotelDayISO, nowHotel } = useFormatDate()
    const params = useParams()
    const { hotel_id } = useProfile()

    const { data: turnos } = useGetTurnosQuery({
        variables: {
            hotel_id,
        },
    })

    const date_param = params?.date?.split("&")
    const fecha_inicial = getStartOfHotelDayISO(getDateParam(date_param?.[0], nowHotel))
    const fecha_final = getStartOfHotelDayISO(getDateParam(date_param?.[1] || date_param?.[0], nowHotel))
    
    return {
        fecha_inicial: fecha_inicial,
        fecha_final: fecha_final,
        fecha_corte_inicial: formatCustomDate(fecha_inicial, "YYYY-MM-DD"),
        fecha_corte_final: formatCustomDate(fecha_final, "YYYY-MM-DD"),
        ready: Number(turnos?.turnos?.length || 0) > 0,
        range: !!date_param?.[1],
    }
}
